import { useState } from 'react';

import { LinkModalProps } from './link-modal.component';

export const useLinkModal = (props: LinkModalProps) => {
    const [href, setHref] = useState<string>(props.initialData.href || '');
    const [text, setText] = useState<string>(props.initialData.text || '');
    const [target, setTarget] = useState<string>(props.initialData.target || '_self');
    const canUnlink = Boolean(props.isEditing || props.initialData.href);

    return {
        href,
        setHref,
        text,
        setText,
        target,
        setTarget,
        canUnlink
    };
};
